<!-- 测评项目设置 -->
<template>
  <div class="ceping-item-setting">
    <div class="total-box flex-between">
      <div @click="selectCepingCategory">{{cepingCategoryText}}<van-icon
        class="xiala"
        class-prefix="vxs-icon"
        name="system_choose"
        size="10"
        color="var(--g6)"
      /></div>
      <!-- <div>测评项目数量：{{totalCount}}</div> -->
      <div @click="showPopup1=true">{{ cepingCategoryStatusText }}<van-icon
        class="xiala"
        class-prefix="vxs-icon"
        name="system_choose"
        size="10"
        color="var(--g6)"
      /></div>
    </div>
    <vx-list
      class="wrapper"
      enable
      :api="api"
      :params="params"
      @load="onLoad"
      ref="listScroller"
      firstShowLoading
    >
      <div class="card-box" v-for="item in list" :key="item.id">
        <div class="card flex-between van-hairline--bottom">
          <div class="left"><van-icon
            class-prefix="vxs-icon"
            name="system_del"
            size="var(--fs-lg)"
            color="var(--c3)"
            @click.stop="deleteItems(item)"
          />{{item.name}}</div>
          <div class="right" @click.stop="updateItems(item)">
            <van-icon
              name="edit"
              class="editicon"
            />修改
          </div>
        </div>
      </div>
      <empty-page :show="list.length === 0 && !loading" tips="还没有测评项目哦~"></empty-page>
    </vx-list>
    <pageFooterBtn btnText="新增测评项目" @click="addCepingItem" />
    <!-- 状态 -->
    <van-action-sheet v-model="showPopup1" :round="false" get-container="body">
      <div class="show-ceping-category-status-popup">
        <div class="head">
          <div class="til">状态</div>
        </div>
        <div class="linewrap">
          <div
            class="line van-hairline--bottom"
            v-for="(status, index) in statusLists"
            :key="index"
            @click="onselectStatus(status)" 
          >
            <div class="l">
              <div class="name">{{ status.name }}</div>
            </div>
            <div class="r">
              <van-icon name="success" size="20" v-if="params.statusList.indexOf(status.id)>=0" class='active'/>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import emptyPage from '@teacher/components/empty-page.vue';

export default {
  name: 'cepingItemSetting',
  data() {
    return {
      pageTitle: '测评项目设置',
      api: this.$api.evaluationItemList,
      params: {
        itemTypeIds: [],
        statusList: [1]   //1启用  0停用
      },
      list: [],
      itemTypeLists: [],
      // totalCount: 0,
      loading: false,
      showPopup1: false,
      statusLists: [{
        id: 0,
        name: '停用'
      },{
        id: 1,
        name: '启用'
      }]
    }
  },
  computed: {
    cepingCategoryText: function () {
      let its = this.params.itemTypeIds,
        text = '';
      if (its.length == 0) {
        text = '全部测评项目类型';
      } else if (its.length == 1) {
        text = this.itemTypeLists[0].name;
      } else {
        text = `${its.length}个测评项目类型`;
      }
      return text;
    },
    cepingCategoryStatusText: function() {
      let its = this.params.statusList,
        text = '';
      if (its.length == 1) {
        text = ['停用','启用'][its[0]];
      } else {
        text = '全部状态';
      }
      return text;
    }
  },
  methods: {
    onLoad(list, res) {
      this.loading = false;
      this.list = list;
      // this.totalCount = res && res.page && res.page.totalCount;
    },
    onselectStatus(status) {
      let i = this.params.statusList.indexOf(status.id);
      if (i === -1) {
        this.params.statusList.push(status.id);
      } else {
        this.params.statusList.splice(i, 1);
      }
    },
    // 删除测评项目
    async deleteItems(item) {
      await vant.Dialog.confirm({
        title: '提示',
        message: `确定要删除 ${item.name} 吗？`,
        messageAlign: 'left',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      });
      this.showLoading();
      this.$api.evaluationItemDelete({
        id: item.id
      }).then(res=> {
        if (res.code == 200) {
          this.$toast.success('删除成功');
          this.$refs.listScroller.refresh();
        } else if(res.code == 830000041) { // 测评项目如有被报告使用，则可修改不可删除
          vant.Dialog.alert({
            title: '提示',
            message: res.msg,
            confirmButtonText: '我知道了',
            confirmButtonColor: 'var(--g8)',
          });
        } else {
          this.$toast.fail(res.msg);        
        }
      }).finally(()=>{
        vant.Toast.clear();
      })
    },
    // 修改测评项目
    async updateItems(item) {
      this.$router.push(`/cepingItemAdd?scene=edit&id=${item.id}`);
    },
    // 新增测评项目
    addCepingItem() {
      this.$router.push('/cepingItemAdd');
    },
    async selectCepingCategory() {
      let res = await app.x3.side.xsCepingCategoryFiltrate({
        ids: this.params.itemTypeIds,
        list: this.itemTypeLists,
      });
      this.params.itemTypeIds = res.ids;
      this.itemTypeLists = res.list;
    },
  },
  async created() {
    this.$onBus('refresh-ceping-item-setting', () => {
      this.showLoading();
      setTimeout(() => {        
        this.$refs.listScroller.refresh();
      }, 1000);
    });
  },
  components: {
    pageFooterBtn,
    emptyPage
  }
}
</script>

<style lang="scss" scoped>
.ceping-item-setting {
  display: flex;
  flex-direction: column;
  .total-box {
    padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
    color: var(--g6);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    text-align: right;
  }
  .wrapper {
    flex: 1;
    .card-box {
      background-color: #fff;
      .card {
        padding: calc(var(--gap) * 16) 0;
        margin: 0 calc(var(--gap) * 16);
        color: var(--g7);
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        .left {
          flex: 1;
          .vxs-icon-system_del {
            margin-right: calc(var(--gap) * 10);
          }
        }
        .right {
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--c1);
          .editicon {
            margin-right: calc(var(--gap) * 2);
            vertical-align: text-bottom;
          }
        }
      }
    }
  }
}

.show-ceping-category-status-popup {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .linewrap {
    padding: 0 calc(var(--gap) * 16);
    .line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) 0;
      height: calc(var(--gap) * 52);
      .l {
        .name {
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          color: var(--g8);
        }
        .desc {
          margin-top: calc(var(--gap) * 4);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
      .r {
        line-height: 0;
        padding: 8px;
        margin-right: -8px;
        .inactive {
          color: var(--g6);
        }
        .active {
          color: var(--c1);
        }
      }
    }
  }
}
</style>